import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage, gbp } from "../../lib/api";

// Unit price cell of a price-history row: effective (discounted) price, the printed price struck through, and — when the extractor
// could not reconcile a printed discount — the owner's choice: use the discounted price everywhere or keep the printed one.
export default function DiscountCell({ row, index, canEdit, onSaved }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const decide = async (useDiscount) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/invoice-lines/${row.line_id}/discount`, { use_discount: useDiscount });
      toast.success(useDiscount ? `Discounted price ${gbp(data.unit_price)} is now used in comparisons, charts and New Order` : `Printed price ${gbp(data.unit_price)} confirmed`);
      setOpen(false);
      onSaved?.(data);
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <>
      {gbp(row.unit_price)}
      {row.list_unit_price != null && row.discount_amount ? <span className="block text-[10px] font-normal text-slate-500" data-testid={`price-history-discount-${index}`}><s>{gbp(row.list_unit_price)}</s> − {gbp(row.discount_amount)} discount{row.discount_pct ? ` (${Number(row.discount_pct).toFixed(2).replace(/\.?0+$/, "")}%)` : ""}</span> : null}
      {row.discount_review ? (
        <button type="button" onClick={() => canEdit && setOpen((v) => !v)} className="block w-full text-right text-[10px] font-normal text-amber-700 hover:underline" title={row.discount_review} data-testid={`price-history-discount-review-${index}`}>
          discount printed — {canEdit ? "resolve" : "check"}
        </button>
      ) : null}
      {open && (
        <div className="mt-1 rounded border border-amber-200 bg-amber-50 p-2 text-left text-[11px] font-sans font-normal text-amber-900 normal-case" data-testid={`price-history-discount-resolve-${index}`}>
          <p>{row.discount_review}</p>
          <div className="mt-1.5 flex flex-wrap justify-end gap-1.5">
            {row.discount_candidate_price != null && <button type="button" disabled={busy} onClick={() => decide(true)} className="rounded bg-emerald-600 px-2 py-1 font-semibold text-white hover:bg-emerald-700 disabled:opacity-50" data-testid={`price-history-discount-use-${index}`}>Use discounted {gbp(row.discount_candidate_price)}</button>}
            <button type="button" disabled={busy} onClick={() => decide(false)} className="rounded border border-slate-300 bg-white px-2 py-1 font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50" data-testid={`price-history-discount-keep-${index}`}>Keep printed {gbp(row.unit_price)}</button>
          </div>
        </div>
      )}
    </>
  );
}
